import {
  createContext,
  type Dispatch,
  type PropsWithChildren,
  type SetStateAction,
  useState,
} from 'react';

import {
  type Settings,
  SettingsMapType,
  SettingsViewMode,
} from '../entities/settings';

export const SettingsContext = createContext<
  [Settings, Dispatch<SetStateAction<Settings>>]
>(
  // @ts-expect-error - This is a placeholder value that should never be used
  undefined,
);

export function defaultSettings(): Settings {
  return {
    mapType: SettingsMapType.SATELLITE,
    viewMode: SettingsViewMode.BIRDS_EYE_VIEW,
    fovForBirdsEyeView: 45,
    fovForPOVView: 60,
  };
}

export type SettingsProviderProps = PropsWithChildren<{}>;

export function SettingsProvider({ children }: SettingsProviderProps) {
  const state = useState<Settings>(defaultSettings);

  return (
    <SettingsContext.Provider value={state}>
      {children}
    </SettingsContext.Provider>
  );
}
